import { computed } from 'vue'
import { useLocalStorage } from '@vueuse/core'

type BaseFormType = {
  selectionModel: string[] // 新增
  keywords: string[]
  brandWords: string[]
  productOrService: string
  websiteInfo: string
  language: string // v1.3.0 语言
}

const defaultData = () => {
  return {
    productOrService: '',
    keywords: ['', '', '', ''],
    brandWords: ['', '', '', ''], // v1.1.0 品牌词
    selectionModel: [''], // v1.1.0 用户选择的模型
    websiteInfo: '',
    language: 'US', // v1.3.0 语言
  }
}
const geoMode = useLocalStorage('geoMode', 'inner')
const innerFormData = useLocalStorage<BaseFormType>('formData', defaultData(), {
  mergeDefaults: true,
})
const ydylFormData = useLocalStorage<BaseFormType>('ydyl-formData', defaultData(), {
  mergeDefaults: true,
})

// 初始化本地存储数据
export const formData = computed({
  get: () => {
    if (geoMode.value === 'inner') {
      return innerFormData.value
    }
    return ydylFormData.value
  },
  set: val => {
    if (geoMode.value === 'inner') {
      innerFormData.value = val
    } else {
      ydylFormData.value = val
    }
  },
})

export const initFormData = () => {
  formData.value = defaultData()
}
